export const ANALYTICS_REGISTRATION_PAGE = '|A|REGISTRATION_PAGE'
export const ANALYTICS_REGISTRATION_BTN_CLICKED = '|A|REGISTRATION_BTN_CLICKED'
export const ANALYTICS_REGISTRATION_CLOSED = '|A|REGISTRATION_CLOSED'
export const ANALYTICS_REGISTRATION_SUBMITTED_SUCCESS = '|A|REGISTRATION_SUBMITTED_SUCCESS'
export const ANALYTICS_KEYBOARD_PRESSED = '|A|KEYBOARD_PRESSED'
export const ANALYTICS_ACTION_BUTTON_CLICKED = '|A|ACTION_BUTTON_CLICKED'
export const ANALYTICS_SET_STOP_INITIATED_BY = 'SET_STOP_INITIATED_BY'
export const ANALYTICS_ELAPSED_TIME = '|A|ELAPSED_TIME'
export const ANALYTICS_DESKTOP_SUCCESS_VIEWED = '|A|DESKTOP_SUCCESS_VIEWED'
export const ANALYTICS_DESKTOP_SUCCESS_DONE_CLICKED = '|A|DESKTOP_SUCCESS_DONE_CLICKED'
export const ANALYTICS_LOCATION_BUTTON_HOVERED = '|A|LOCATION_BUTTON_HOVERED'
export const ANALYTICS_SET_USER_KEY = '|A|SET_USER_KEY'
export const ANALYTICS_SET_SESSION_ID = '|A|SET_SESSION_ID'
export const ANALYTICS_SET_PAGE_SESSION_ID = '|A|ANALYTICS_SET_PAGE_SESSION_ID'
export const ANALYTICS_VR_BUTTON_TAPPED = '|A|VR_BUTTON_TAPPED'
export const ANALYTICS_CONTEXTMENU_ITEM_CLICKED = '|A|CONTEXTMENU_ITEM_CLICKED'
export const ANALYTICS_EXP_SELECTED = '|A|EXP_SELECTED'
export const ANALYTICS_CHANGE_STOPCARD = '|A|CHANGE_STOPCARD'
export const ANALYTICS_STOPCARD_SUPPMEDIA_SWIPE = '|A|STOPCARD_SUPPMEDIA_SWIPE'
export const ANALYTICS_DESCRIPTION_SCROLL_COMPLETE = '|A|DESCRIPTION_SCROLL_COMPLETE'
export const ANALYTICS_INFO_BUTTON_CLICKED = '|A|INFO_BUTTON_CLICKED'
export const ANALYTICS_REGISTRATION_EXTERNAL_LINK_CLICKED = '|A|REGISTRATION_EXTERNAL_LINK_CLICKED'
export const ANALYTICS_AUDIO_BUTTON_CLICKED = '|A|AUDIO_BUTTON_CLICKED'
export const ANALYTICS_SET_ATTRIBUTES = '|A|ANALYTICS_SET_ATTRIBUTES'
export const ANALYTICS_FIRST_STOP_VIEWED = 'Exp_FirstStop_Viewed'
export const ANALYTICS_SUPERCONTENT_STARTED = '|A|ANALYTICS_SUPERCONTENT_STARTED'

//Mobile only
export const ANALYTICS_HYBRID_APP_EVENT = '|A|HYBRID_APP_EVENT'

import Analytics from './utils/analytics'

export const registrationPage = page => {
    return {
        type: ANALYTICS_REGISTRATION_PAGE,
        page,
    }
}

export const registrationButtonClicked = (btnName, data) => {
    return {
        type: ANALYTICS_REGISTRATION_BTN_CLICKED,
        name: btnName,
        data,
    }
}

export const registrationClosed = (page, fields) => {
    return {
        type: ANALYTICS_REGISTRATION_CLOSED,
        page,
        fields,
    }
}

export const actionButtonClicked = ({ action, color, name }) => {
    if (action) Analytics.sendAnalytics(action)

    return {
        type: ANALYTICS_ACTION_BUTTON_CLICKED,
        name,
        color,
        actionName: action,
    }
}

export const sendKeyboardPress = (actionName, keyPressed) => {
    if (actionName) Analytics.sendAnalytics(actionName)

    return {
        type: ANALYTICS_KEYBOARD_PRESSED,
        actionName: actionName,
        keyPressed: keyPressed,
    }
}

export const setStopInitiatedBy = initiatedBy => {
    return {
        type: ANALYTICS_SET_STOP_INITIATED_BY,
        initiatedBy,
    }
}

export const setElapsedTime = time => {
    return {
        type: ANALYTICS_ELAPSED_TIME,
        time,
    }
}

export const desktopRegSuccessViewed = () => {
    return {
        type: ANALYTICS_DESKTOP_SUCCESS_VIEWED,
    }
}

export const desktopRegSuccessDoneClicked = () => {
    return {
        type: ANALYTICS_DESKTOP_SUCCESS_DONE_CLICKED,
    }
}

export const analyticsExperienceSelected = () => {
    return {
        type: ANALYTICS_EXP_SELECTED,
    }
}

export const locationButtonHovered = () => ({
    type: ANALYTICS_LOCATION_BUTTON_HOVERED,
})

export const registrationSubmittedSuccessfully = () => ({
    type: ANALYTICS_REGISTRATION_SUBMITTED_SUCCESS,
})

//This action tracks all event that we want to know about
//for the hybridapp related events
//just pass in the event we want to track as obj param
//i.e. { event: M_MOBEXP_SIDEWAY_VISIBLE }
export const sendHybridAppAnalyticsEvents = ({ event }) => {
    return {
        type: ANALYTICS_HYBRID_APP_EVENT,
        event,
    }
}

export const vrButtonTapped = ({ buttonLocation }) => {
    return {
        type: ANALYTICS_VR_BUTTON_TAPPED,
        buttonLocation,
    }
}

export const contextMenuItemClicked = ({ itemName }) => {
    return {
        type: ANALYTICS_CONTEXTMENU_ITEM_CLICKED,
        itemName,
    }
}

export const changeStopCard = () => {
    return {
        type: ANALYTICS_CHANGE_STOPCARD,
    }
}

export const stopCardSupplementalMediaSwiped = () => {
    return {
        type: ANALYTICS_STOPCARD_SUPPMEDIA_SWIPE,
    }
}
export const descriptionScrollComplete = () => {
    return {
        type: ANALYTICS_DESCRIPTION_SCROLL_COMPLETE,
    }
}

export const registrationExternalLinkClicked = ({ eventName }) => ({
    type: ANALYTICS_REGISTRATION_EXTERNAL_LINK_CLICKED,
    eventName,
})

export const infoButtonClicked = () => ({
    type: ANALYTICS_INFO_BUTTON_CLICKED,
})

export const audioButtonClicked = () => ({
    type: ANALYTICS_AUDIO_BUTTON_CLICKED,
})

export const setAnalyticAttributes = attributes => ({
    type: ANALYTICS_SET_ATTRIBUTES,
    attributes,
})

export const setSessionId = sessionId => ({
    type: ANALYTICS_SET_SESSION_ID,
    sessionId,
})

export const setPageSessionId = pageSessionId => ({
    type: ANALYTICS_SET_PAGE_SESSION_ID,
    pageSessionId,
})

export const superContentStarted = _ => ({
    type: ANALYTICS_SUPERCONTENT_STARTED,
})
